<template>
  <div id="app">

    <template v-if="isCheckingAuth">
      <md-progress-spinner md-mode="indeterminate"/>
    </template>
    <template v-else>
      <template v-if="isLoggedIn">

        <div class="page-container">
          <md-app md-waterfall md-mode="fixed">

            <!--<md-app-toolbar class="noprint md-primary" md-elevation="0">-->
            <md-app-toolbar class="noprint md-primary" 
                  v-bind:class="{ custom_app_toolbar_appt: getCurrentToolbarDisplay.indexOf('Appointments') > 0,
                    custom_app_toolbar_data: getCurrentToolbarDisplay.indexOf('Data Management') > 0,
                    custom_app_toolbar_scale: getCurrentToolbarDisplay.indexOf('Scaling') > 0 } " 
                  md-elevation="0">  
              <md-button class="md-icon-button" @click="toggleMenu" v-if="!menuVisible">
                <md-icon>menu</md-icon>
              </md-button>
              <h3 style="flex: 1;" class="md-title">{{getCurrentToolbarDisplay}}</h3>
              <div style="text-align: right">
                <div style="font-size: 16px">{{getEnv}}</div>
                <div>{{getCurrentDateDisplay}}&nbsp; <span style="font-size: 8px">Build {{getAppVersion}}</span></div>
                <calling-api path="/api/w/users/me">
                  <div style="font-size: 18px" v-if="getUserProfile">
                    <b>{{getUserProfile.name}}</b>
                    <span style="font-size: 14px">&nbsp;(<master-data-display
                        group="UserCategory"
                        :tag-id="getUserProfile.category"/>)</span>
                  </div>
                  <div>
                     Login Location: {{ user_location }}
                     <span v-if="getUserProfile.username == 'ALEXW' || getUserProfile.username == 'DAVIDL'
                             || getUserProfile.username == 'ALLENL'">
                              ({{user_ip}})
                             </span>
                  </div>
                </calling-api>
              </div>
            </md-app-toolbar>


            <md-app-drawer class = "noprint" :md-active.sync="menuVisible" md-persistent="full" >
              <md-toolbar class="md-transparent" md-elevation="0">
                <span>Navigation</span>

                <div class="md-toolbar-section-end">
                  <md-button class="md-icon-button md-dense" @click="toggleMenu">
                    <md-icon>keyboard_arrow_left</md-icon>
                  </md-button>
                </div>
              </md-toolbar>

        




      <md-list>

        <md-list-item md-expand>
           <!-- <md-icon>people</md-icon> -->
           <span class="md-list-item-text">General</span>
            <md-list slot="md-expand">
              <md-list-item class="md-inset" to="/users" v-if="getPermission.acnit.view && getPermission.users.view">
                  <md-icon>people</md-icon>
                  <span class="md-list-item-text">User</span>
              </md-list-item>
              <md-list-item class="md-inset" to="/UserSettings">
                  <md-icon>people</md-icon>
                  <span class="md-list-item-text">User Settings</span>
              </md-list-item>

              <md-list-item class="md-inset" to="/settings/masterData" :class="getRouteLinkActiveClass('/settings/masterData')"
                              v-if="getPermission.acnit.view && getPermission.settings.view">
                  <md-icon>settings</md-icon>
                  <span class="md-list-item-text">Settings</span>
              </md-list-item>

              <md-list-item class="md-inset" to="/version/web" v-if="getPermission.acnit.view && getPermission.settings.view">
                  <md-icon>phonelink</md-icon>
                  <span class="md-list-item-text">Version Control</span>
              </md-list-item>

            </md-list>
        </md-list-item>

        <!-- <md-list-item md-expand v-if="getPermission.acnit.view">
           <span class="md-list-item-text">CCR</span>
            <md-list slot="md-expand">
              <md-list-item class="md-inset" to="/ccrlog" v-if="getPermission.users.view">
                  <md-icon>people</md-icon>
                  <span class="md-list-item-text">CCR Log</span>
              </md-list-item>
            </md-list>
        </md-list-item> -->


        <md-list-item md-expand v-if="getPermission.fsi_menu.view">
           <!-- <md-icon>people</md-icon> -->
           <span class="md-list-item-text">FSI</span>
            <md-list slot="md-expand">
              <md-list-item class="md-inset" to="/loadList" v-if="getPermission.fsi.view || getPermission.stc.view || getPermission.ccic.view">
                  <md-icon>list_alt</md-icon>
                  <span class="md-list-item-text">Container/Load List</span>
                </md-list-item>

              <!-- <md-list-item class="md-inset" to="/si/headers" v-if="getPermission.si.view || getPermission.do.view">
                  <md-icon>today</md-icon>
                  <span class="md-list-item-text">Shipping Instruction</span>
              </md-list-item> -->
              
              <!--
              <md-list-item class="md-inset" to="/fsiOperationCockpit/inbound" v-if="getPermission.opcockpiti.view || getPermission.opcockpito.view">
                  <md-icon>class</md-icon>
                  <span class="md-list-item-text">Inbound Cockpit</span>
              </md-list-item>
            -->
              <md-list-item class="md-inset" md-expand  v-if="getPermission.opcockpiti.view || getPermission.opcockpito.view">
                  <md-icon>forward</md-icon>
                  <span class="md-list-item-text">Inbound Cockpit</span>
                  <md-list slot="md-expand">
                      <md-list-item class="md-inset" to="/inboundCockpitNew/inboundAppt" :class="getRouteLinkActiveClass('/inboundCockpitNew/inboundAppt')">
                          <md-icon>local_shipping</md-icon>
                          <span class="md-list-item-text">Appointments</span>
                      </md-list-item>
                      <md-list-item class="md-inset" to="/inboundCockpitNew/inboundScale" :class="getRouteLinkActiveClass('/inboundCockpitNew/inboundScale')">
                          <md-icon>call</md-icon>
                          <span class="md-list-item-text">Check In & Data</span>
                      </md-list-item>
                      <md-list-item class="md-inset" to="/inboundCockpitNew/inboundTM" :class="getRouteLinkActiveClass('/inboundCockpitNew/inboundTM')">
                          <md-icon>rv_hookup</md-icon>
                          <span class="md-list-item-text">Scaling Management</span>
                      </md-list-item>
                      <md-list-item class="md-inset" to="/inboundCockpitNew/ocReports" :class="getRouteLinkActiveClass('/inboundCockpitNew/ocReports')">
                          <md-icon>local_printshop</md-icon>
                          <span class="md-list-item-text">Reports</span>
                      </md-list-item>
                  </md-list>
              </md-list-item>
              <md-list-item class="md-inset" md-expand  v-if="getPermission.opcockpiti.view || getPermission.opcockpito.view">
                 <md-icon>arrow_back</md-icon>
                 <span class="md-list-item-text">Outbound Cockpit</span>
                  <md-list slot="md-expand">
                      <md-list-item class="md-inset" to="/outboundCockpitNew/outboundCockpit" :class="getRouteLinkActiveClass('/outboundCockpitNew/outboundCockpit')">
                          <md-icon>widgets</md-icon>
                          <span class="md-list-item-text">Cockpit</span>
                      </md-list-item>
                      <md-list-item class="md-inset" to="/outboundCockpitNew/outboundList" :class="getRouteLinkActiveClass('/outboundCockpitNew/outboundList')">
                          <md-icon>local_printshop</md-icon>
                          <span class="md-list-item-text">Reports</span>
                      </md-list-item>
                  </md-list>
              </md-list-item>
              <!--
              <md-list-item class="md-inset" to="/outboundCockpitNew/outboundCockpit" v-if="getPermission.opcockpiti.view || getPermission.opcockpito.view">
                  <md-icon>arrow_back</md-icon>
                  <span class="md-list-item-text">Outbound Cockpit</span>
              </md-list-item>
            -->
              <md-list-item class="md-inset" to="/ccic/applications" v-if="getPermission.ccic.view"
                              :class="getRouteLinkActiveClass('/ccic')">
                  <md-icon>copyright</md-icon>
                  <span class="md-list-item-text">Ccic</span>
              </md-list-item>
              <!--
              <md-list-item class="md-inset" to="/ibslist/ibsinbound" v-if="getPermission.ibslist.view || getPermission.ibslistob.view || getPermission.fsiac2.view">
                  <md-icon>thumb_up</md-icon>
                  <span class="md-list-item-text">IBS List</span>
              </md-list-item>
              -->
              <md-list-item class="md-inset" to="/ibslist" v-if="getPermission.ibslist.view || getPermission.ibslistob.view || getPermission.fsiac2.view">
                  <md-icon>thumb_up</md-icon>
                  <span class="md-list-item-text">IBS List</span>
              </md-list-item>

              <md-list-item class="md-inset" to="/ibslist3rdparty" v-if="getPermission.ibslist.view || getPermission.fsiac2.view || getPermission.ibslist3p.view">
                  <md-icon>class</md-icon>
                  <span class="md-list-item-text">3rd Party IBS Cockpit</span>
              </md-list-item>
	      
              <md-list-item class="md-inset" to="/FSIDailyreport/FSIDailyreportInbound" v-if="getPermission.fsi.view || getPermission.acnit.view">
                <md-icon>highlight</md-icon>
                <span class="md-list-item-text">Daily Progress Report</span>
            </md-list-item>
            
              <md-list-item class="md-inset" to="/downloadApp">
                  <md-icon>mobile_screen_share</md-icon>
                  <span class="md-list-item-text">Download Apps</span>
              </md-list-item>

              <md-list-item class="md-inset" md-expand v-if="getPermission.masterdata.view || getPermission.fsiMgt.edit || getPermission.fsiMgtWithRemark.edit">
                <md-icon>build</md-icon><span class="md-list-item-text">FSI Master Data</span>
                <md-list slot="md-expand">

                  <!-- <md-list-item class="md-inset" to="/masterDataApp" :class="getRouteLinkActiveClass('/masterDataApp')"
                                  v-if="getPermission.settings.view">
                      <md-icon>settings</md-icon>
                      <span class="md-list-item-text">Appointment Master</span>
                  </md-list-item> -->

                  <md-list-item class="md-inset" to="/masterDataYG" :class="getRouteLinkActiveClass('/masterDataYG')"
                                  v-if="getPermission.masterdata.view || getPermission.fsiMgt.edit || getPermission.fsiMgtWithRemark.edit">
                      <md-icon>settings</md-icon>
                      <span class="md-list-item-text">Yard Goat Master</span>
                  </md-list-item>

                  <md-list-item class="md-inset" to="/masterDataApp" :class="getRouteLinkActiveClass('/masterDataApp')"
                                  v-if="getPermission.masterdata.view">
                      <md-icon>settings</md-icon>
                      <span class="md-list-item-text">Appointment Master</span>
                  </md-list-item>
                  
                  <md-list-item class="md-inset" to="/masterDataTemplateApp" :class="getRouteLinkActiveClass('/masterDataTemplateApp')"
                                  v-if="getPermission.masterdata.view || getPermission.fsiMgt.edit || getPermission.fsiMgtWithRemark.edit">
                      <md-icon>settings</md-icon>
                      <span class="md-list-item-text">Template Appointment Master</span>
                  </md-list-item>
                  
                  <md-list-item class="md-inset" to="/MasterDataCarrier" :class="getRouteLinkActiveClass('/MasterDataCarrier')"
                                  v-if="getPermission.masterdata.view">
                      <md-icon>settings</md-icon>
                      <span class="md-list-item-text">Carrier</span>
                  </md-list-item>

                  <!--<md-list-item class="md-inset" to="/DriverMaster" :class="getRouteLinkActiveClass('/DriverMaster')"-->
                  <md-list-item class="md-inset" to="/FSIDriverMaster" :class="getRouteLinkActiveClass('/FSIDriverMaster')"
                                  v-if="getPermission.masterdata.view || getPermission.fsiMgt.edit || getPermission.fsiMgtWithRemark.edit">
                      <md-icon>settings</md-icon>
                      <span class="md-list-item-text">Driver</span>
                  </md-list-item>

                  <md-list-item class="md-inset" to="/scalecontrol/out" v-if="getPermission.scalecontrol.view">
                    <md-icon>settings</md-icon>
                    <span class="md-list-item-text">Scale Control</span>
                  </md-list-item>
              


                </md-list>
              </md-list-item>

            </md-list>
        </md-list-item>


        <md-list-item md-expand v-if="getPermission.acnit.view || getPermission.stc.view || getPermission.stcloadlistupdate.view || getPermission.stcExtraCost.view">
           <!-- <md-icon>people</md-icon> -->
           <span class="md-list-item-text">STC</span>
            <md-list slot="md-expand">

              <md-list-item class="md-inset" to="/priceMangement" v-if="getPermission.stcMgt.view || getPermission.acnit.view || getPermission.stcAcct.view || getPermission.stcWithPM.view || getPermission.stcreadonly.view || getPermission.stcfsireadonlyforerlmgt.view">

                  <md-icon>format_list_bulleted</md-icon>
                  <span class="md-list-item-text">STC Price Managment</span>
                </md-list-item>

              <md-list-item class="md-inset" to="/do/headers" v-if="getPermission.do.view || getPermission.stc.view || getPermission.doReadOnly.view">
                  <md-icon>today</md-icon>
                  <span class="md-list-item-text">Delivery Order</span>
                </md-list-item>

              <md-list-item class="md-inset" to="/loadList" v-if="getPermission.ccic.view || getPermission.stc.view || getPermission.stcloadlistupdate.view">
                  <md-icon>list_alt</md-icon>
                  <span class="md-list-item-text">Container/Load List</span>
                </md-list-item>

              <md-list-item class="md-inset" md-expand v-if="getPermission.ccic.view || getPermission.stc.view || getPermission.stcExtraCost.view">
                  <md-icon>watch_later</md-icon>
                  <span class="md-list-item-text">Dispatch</span>
                  <md-list slot="md-expand">
                    <md-list-item class="md-inset" to="/dispatch/load" :class="getRouteLinkActiveClass('/dispatch/load')"
                         v-if="getPermission.stc.view || getPermission.acnit.view || getPermission.stcExtraCost.view">
                        <md-icon>local_shipping</md-icon>
                        <span class="md-list-item-text">Load</span>   
                    </md-list-item>
                    <md-list-item class="md-inset" to="/dispatch/stage" :class="getRouteLinkActiveClass('/dispatch/stage')"
                         v-if="getPermission.stc.view || getPermission.acnit.view || getPermission.stcExtraCost.view">
                        <md-icon>widgets</md-icon>
                        <span class="md-list-item-text">Stage</span>   
                    </md-list-item>
                  </md-list>
                </md-list-item>

              <!-- <md-list-item class="md-inset" to="/gstLoadAndStage/gstLoads" v-if="getPermission.settings.view || getPermission.stc.view">
                  <md-icon>playlist_add_check</md-icon>
                  <span class="md-list-item-text">STC Load & Stage</span>
                </md-list-item> -->

              <md-list-item class="md-inset" to="/confirm/aparload" v-if="getPermission.stc.view && !getPermission.stcfsireadonlyforerl.view">
                  <md-icon>attach_money</md-icon>
                  <span class="md-list-item-text">Billing/Cost Maintain</span>
                </md-list-item>

              <md-list-item class="md-inset" to="/payroll/settlement" v-if="getPermission.stc.view && !getPermission.stcreadonly.view">
                  <md-icon>group</md-icon>
                  <span class="md-list-item-text">Driver Payroll</span>
                </md-list-item>

              <md-list-item class="md-inset" to="/lock/load" v-if="getPermission.stc.view && !getPermission.stcfsireadonlyforerl.view">
                  <md-icon>lock</md-icon>
                  <span class="md-list-item-text">Lock Billing/Cost</span>
                </md-list-item>

              <md-list-item v-if="getPermission.stcMgt.view || getPermission.stcAuditOnly.view || getPermission.settings.view" class="md-inset" md-expand><md-icon>build</md-icon><span class="md-list-item-text">STC Master Data</span>
                <md-list slot="md-expand">
                  <md-list-item class="md-inset" to="/DriverGroupData" :class="getRouteLinkActiveClass('/DriverGroupData')"
                                  v-if="(getPermission.settings.view || getPermission.stcMgt.view || getPermission.stcAuditOnly.view)">
                      <md-icon>settings</md-icon>
                      <span class="md-list-item-text">Driver Group</span>
                  </md-list-item>

                  <md-list-item class="md-inset" to="/MasterDataDriver" :class="getRouteLinkActiveClass('/MasterDataDriver')"
                                  v-if="(getPermission.settings.view || getPermission.stcMgt.view || getPermission.stcAuditOnly.view)">
                      <md-icon>settings</md-icon>
                      <span class="md-list-item-text">Driver</span>
                  </md-list-item>

                  <md-list-item class="md-inset" to="/MasterDataDriverCompany" :class="getRouteLinkActiveClass('/MasterDataDriverCompany')"
                                  v-if="(getPermission.settings.view || getPermission.stcMgt.view || getPermission.stcAuditOnly.view)">
                      <md-icon>settings</md-icon>
                      <span class="md-list-item-text">Driver Company</span>
                  </md-list-item>

                  <md-list-item class="md-inset" to="/MasterDataCarrier" :class="getRouteLinkActiveClass('/MasterDataCarrier')"
                                  v-if="(getPermission.settings.view || getPermission.stcMgt.view || getPermission.stcAuditOnly.view)">
                      <md-icon>settings</md-icon>
                      <span class="md-list-item-text">Carrier</span>
                  </md-list-item>

                  <md-list-item class="md-inset" to="/MasterDataChassisVendor" :class="getRouteLinkActiveClass('/MasterDataChassisVendor')"
                                  v-if="(getPermission.settings.view || getPermission.stcMgt.view || getPermission.stcAuditOnly.view)">
                      <md-icon>settings</md-icon>
                      <span class="md-list-item-text">Chassis Vendor</span>
                  </md-list-item>

                  <md-list-item class="md-inset" to="/MasterDataCustomer" :class="getRouteLinkActiveClass('/MasterDataCustomer')"
                                  v-if="(getPermission.settings.view || getPermission.stcMgt.view || getPermission.stcAuditOnly.view)">
                      <md-icon>settings</md-icon>
                      <span class="md-list-item-text">Customer</span>
                  </md-list-item>

                  <md-list-item class="md-inset" to="/MasterDataLeaseChassis" :class="getRouteLinkActiveClass('/MasterDataLeaseChassis')"
                                  v-if="getPermission.settings.view || getPermission.stcMgt.view || getPermission.stcAuditOnly.view">
                      <md-icon>settings</md-icon>
                      <span class="md-list-item-text">Lease Chassis</span>
                  </md-list-item>

                  <md-list-item class="md-inset" to="/MasterDataLocation" :class="getRouteLinkActiveClass('/MasterDataLocation')"
                                  v-if="(getPermission.settings.view || getPermission.stcMgt.view || getPermission.stcAuditOnly.view)">
                      <md-icon>settings</md-icon>
                      <span class="md-list-item-text">Location/Terminal</span>
                  </md-list-item>

                  <md-list-item class="md-inset" to="/MasterDataTruck" :class="getRouteLinkActiveClass('/MasterDataTruck')"
                                  v-if="getPermission.settings.view || getPermission.stcMgt.view || getPermission.stcAuditOnly.view">
                      <md-icon>settings</md-icon>
                      <span class="md-list-item-text">Truck</span>
                  </md-list-item>

                </md-list>
              </md-list-item>
              <md-list-item class="md-inset" to="/downloadApp">
                  <md-icon>mobile_screen_share</md-icon>
                  <span class="md-list-item-text">Download Apps</span>
              </md-list-item>
            </md-list>
        </md-list-item>



        <!-- <md-list-item md-expand v-if="getPermission.acnit.view || getPermission.walmart.view">
           <span class="md-list-item-text">Walmart</span>
            <md-list slot="md-expand">
              <md-list-item class="md-inset" to="/stores" v-if="getPermission.stores.view">
                  <md-icon>location_city</md-icon>
                  <span class="md-list-item-text">Store</span>
                </md-list-item>

              <md-list-item class="md-inset" to="/schedules" v-if="getPermission.schedules.view">
                  <md-icon>local_shipping</md-icon>
                  <span class="md-list-item-text">Schedule</span>
                </md-list-item>

              <md-list-item class="md-inset" to="/loadAndBillOfLoad/loads"
                              :class="getRouteLinkActiveClass('/loadAndBillOfLoad')"
                              v-if="getPermission.loads.view"
                >
                  <md-icon>line_weight</md-icon>
                  <span class="md-list-item-text">Load & BOL</span>
                </md-list-item>

              <md-list-item class="md-inset" to="/callLog"
                              v-if="getPermission.callLogs.view"
                >
                  <md-icon>call</md-icon>
                  <span class="md-list-item-text">Call Log</span>
                </md-list-item>

              <md-list-item class="md-inset" to="/yardQc" v-if="getPermission.yardQc.view">
                  <md-icon>spellcheck</md-icon>
                  <span class="md-list-item-text">Yard QC</span>
                </md-list-item>

              <md-list-item class="md-inset" to="/downloadApp">
                  <md-icon>mobile_screen_share</md-icon>
                  <span class="md-list-item-text">Download Apps</span>
              </md-list-item>

              <md-list-item class="md-inset" md-expand><md-icon>dashboard</md-icon><span class="md-list-item-text">Wal Master Data</span>
                <md-list slot="md-expand">
              
             
                    
                </md-list>
              </md-list-item>

            </md-list>
        </md-list-item> -->






                


                <!-- <md-list-item to="/priceMangement" v-if="getPermission.ccic.view">
                  <md-icon>attach_money</md-icon>
                  <span class="md-list-item-text">GST Price Managment</span>
                </md-list-item>



                <md-list-item to="/do/headers" v-if="getPermission.do.view"
                              :class="getRouteLinkActiveClass('/do')">
                  <md-icon>today</md-icon>
                  <span class="md-list-item-text">Do</span>
                </md-list-item>

                <md-list-item to="/loadList" v-if="getPermission.ccic.view">
                  <md-icon>list_alt</md-icon>
                  <span class="md-list-item-text">Container/Load List</span>
                </md-list-item>


                <md-list-item to="/dispatch/yardexport" v-if="getPermission.ccic.view">
                  <md-icon>local_shipping</md-icon>
                  <span class="md-list-item-text">Dispatch</span>
                </md-list-item>


                <md-list-item to="/gstLoadAndStage/gstLoads" v-if="getPermission.settings.view">
                  <md-icon>playlist_add_check</md-icon>
                  <span class="md-list-item-text">GST Load & Stage</span>
                </md-list-item>



                <md-list-item to="/stores" v-if="getPermission.stores.view">
                  <md-icon>location_city</md-icon>
                  <span class="md-list-item-text">Store</span>
                </md-list-item>

                <md-list-item to="/schedules" v-if="getPermission.schedules.view">
                  <md-icon>local_shipping</md-icon>
                  <span class="md-list-item-text">Schedule</span>
                </md-list-item>

                <md-list-item to="/loadAndBillOfLoad/loads"
                              :class="getRouteLinkActiveClass('/loadAndBillOfLoad')"
                              v-if="getPermission.loads.view"
                >
                  <md-icon>line_weight</md-icon>
                  <span class="md-list-item-text">Load & BOL</span>
                </md-list-item>

                <md-list-item to="/callLog"
                              v-if="getPermission.callLogs.view"
                >
                  <md-icon>call</md-icon>
                  <span class="md-list-item-text">Call Log</span>
                </md-list-item>

                <md-list-item to="/yardQc" v-if="getPermission.yardQc.view">
                  <md-icon>spellcheck</md-icon>
                  <span class="md-list-item-text">Yard QC</span>
                </md-list-item>

                <md-list-item to="/ccic/applications" v-if="getPermission.ccic.view"
                              :class="getRouteLinkActiveClass('/ccic')">
                  <md-icon>copyright</md-icon>
                  <span class="md-list-item-text">Ccic</span>
                </md-list-item>

                <md-list-item to="/downloadApp">
                  <md-icon>mobile_screen_share</md-icon>
                  <span class="md-list-item-text">Download Apps</span>
                </md-list-item> -->

                

                <calling-api :paths="['/api/w/users/me/device','/api/w/users/me']">
                  <md-list-item @click="logout">
                    <md-icon>exit_to_app</md-icon>
                    <span class="md-list-item-text">Logout</span>
                  </md-list-item>
                </calling-api>
              </md-list>
            </md-app-drawer>

            <md-app-content class="app-main-container">
              <calling-api path="/api/w/masterData" :once="true">
                <router-view/>
              </calling-api>
              <md-snackbar :md-active.sync="hasGlobalError" :md-duration="Infinity" :md-persistent="true">
                <span v-if="globalError">Unexpected error: {{globalError.message}}</span>
                <div>
                  <md-button class="md-accent" @click="displayGlobalErrorDetail=true">Detail</md-button>
                  <md-button class="md-primary" @click="refreshPage">Refresh Page</md-button>
                </div>
              </md-snackbar>
              <md-dialog :md-active.sync="displayGlobalErrorDetail">
                <md-dialog-content style="width: 800px;overflow: scroll">
                  <div v-if="getErrorDetail">
                    <div v-if="getErrorDetail.raw">
                      <h3>Error:</h3>
                      <div>
                        {{getErrorDetail.raw.stack}}
                      </div>
                    </div>
                    <div v-if="getErrorDetail.extend">
                      <div v-if="getErrorDetail.extend.config">
                        <div>
                          <h3>Request:</h3>
                          <div>
                            [{{getErrorDetail.extend.config.method}}] {{getErrorDetail.extend.config.url}}
                          </div>
                          <div>
                            {{getErrorDetail.extend.config.body}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </md-dialog-content>
                <md-dialog-actions>
                  <md-button class="md-primary" @click="displayGlobalErrorDetail = false">Close</md-button>
                </md-dialog-actions>
              </md-dialog>
            </md-app-content>

          </md-app>
        </div>

      </template>
      <div v-else>
        <template v-if="isSTC">
          <loginstc/>
        </template>
        <template v-else>
          <!--<Login/>-->
          <LoginMFA/>
        </template>
      </div>  
    </template>
  </div>
</template>

<style lang="scss">
  #app {
    font-family: 'Roboto', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    height: 100vh;
  }

  /* // @media print { 

  //     .noprint {
  //     display:  none; 
  //   }
	// 		.print { 
	// 			display: block !important;
	// 		} 

  //     .page-container, .md-app {
  //       height: 100vh !important;
  //     }
  //   } */



  .page-container, .md-app {
    height: 100vh;
  }

  
  .md-list a.router-link-active, .md-list-item.router-link-active a {
    background: #ccc !important;
    font-weight: 300;
    /*background-color: gray !important;*/
  }

  .router-link-active {
    background: rgb(238, 234, 234) !important;
  }


  .router-link-active-appt {
    background-color: rgb(11, 104, 65) !important;
    color: white !important;
  }

  .router-link-active-scale {
    background-color: rgb(221, 175, 48) !important;
    color: white !important;
  }

  .router-link-active-tm {
    background-color: rgb(135, 55, 151) !important;
    color: white !important;
  }

  .md-select-menu {
    z-index: 50;
  }

  .md-menu-content {
    z-index: 999 !important;
  }

  .md-tooltip {
    z-index: 9999 !important;
  }

  /*.md-autocomplete .md-clear {*/
  /*display: none;*/
  /*}*/

  .md-fab {
    z-index: 2
  }

  form .md-error {
    opacity: 0;
  }

  .md-invalid .md-error {
    opacity: 1;
    transform: translateZ(0);
    color: red;
  }

  .app-main-container {
    padding: 0;
    max-height: calc(100vh - 64px);
    overflow: hidden;
  }

  .md-field {
    margin-bottom: 4px;
  }

  .md-card-content {
    padding: 4px;
    padding-bottom: 8px !important;
  }

  .md-table-head .md-checkbox {
    display: none;
  }

  .md-table-head-label, .md-table-cell-container {
    padding: 4px;
  }

  .md-table-cell {
    height: 24px;
  }

  table .md-field {
    margin: 2px;
    padding-top: 0px;
    min-height: 24px;
  }

  table .md-field .md-clear {
    top: 0;
  }

  .td-60 {
    min-width: 60px;
  }

  .td-80 {
    min-width: 80px;
  }

  .td-120 {
    min-width: 120px;
  }

  .md-scrollbar::-webkit-scrollbar {
    width: 12px;
    height: 12px;
  }

  .md-inset {
    padding-left: 30px;
  }

  .md-inset1 {
    padding-left: 55px;
  }

  .md-drawer {
    width: 280px;
  }

  .md-list-item-content1 {
    padding: 0px 50px 0px 0px !important;
  }

  .md-div-sub-menu {
    margin-left:30px;
  }

  .md-div-sub-menu-span {
    margin-left:-20px; 
    margin-right:20px    
  }
  
  .md-div-sub-menu-list {
    margin-left:20px;
  }

  .custom_app_toolbar_appt {
    background-color: rgb(11, 104, 65) !important;
    /*color: rgb(139, 16, 0) !important;*/
  }
  .custom_app_toolbar_data {
    background-color: rgb(221, 175, 48) !important;
    /*color: rgb(139, 16, 0) !important;*/
  }
  .custom_app_toolbar_scale {
    background-color: rgb(135, 55, 151) !important;
    /*color: rgb(139, 16, 0) !important;*/
  }
  .custom_app_text_appt {
    color: rgb(139, 16, 0) !important;
    font-weight:800;
  } 
  .custom_app_text_data {
    color: rgb(139, 16, 0) !important;
    font-weight:800;
  } 
  .custom_app_text_scale {
    color: rgb(139, 16, 0) !important;
    font-weight:800;
  } 

</style>

<script>
  import { mapGetters } from 'vuex';
  import Login from './views/Login.vue';
  import LoginMFA from './views/LoginMFA.vue';
  import Loginstc from './views/Loginstc.vue';
  import Config from './config.js';
  import String from './string.js';
  import api from "./api";

  export default {
    data: () => ({
      menuVisible: true,
      displayGlobalErrorDetail: false,
      isSTC: false,
      user_ip: null,
      user_location: null,
      office_ips: [],
    }),
    components: {
      Login,
      Loginstc,
      LoginMFA,
    },
    computed: {
      ...mapGetters([
        'getPermission',
        'getUserProfile',
        'getMasterDataByGroup',
        'getUserLocation',
        'getUserIP'
      ]),
      isLoggedIn() {
        return this.$store.state.auth.isLoggedIn;
      },
      isCheckingAuth() {
        return this.$store.state.auth.isCheckingAuth;
      },
      globalError() {
        return this.$store.state.globalError;
      },
      hasGlobalError() {
        return !!this.$store.state.globalError;
      },
      getErrorDetail() {
        const err = {};
        try {
          err.extend = JSON.parse(JSON.stringify(this.globalError));
        } catch (e) {
          console.error(e);
        }

        if (this.globalError != null)
        {
          try {
          err.raw = JSON.parse(JSON.stringify(this.globalError, Object.getOwnPropertyNames(this.globalError)));
          } catch (e) {
          console.error(e);
          }
        }
       
        return err;
      },
      getCurrentToolbarDisplay() {
        return _(this.$route.matched)
          .map(it => it.name)
          .join(" > ");
      },

      getEnv(){
        // return 'Manufacturer: FSI, Model: FSIINVTWEB001 v1.0, NTEP CC: 22-020 ' + Config.env;
        return 'Manufacturer: FSI, Model: FSIINVTWEB001 NTEP CC: 22-020 ' + Config.env + ' v' + String.ver;
      },

      getHost(){
        return window.location.hostname;
      },
      getAppVersion() {
        return window.appVersion || '999999999999';
      },
      getCurrentDateDisplay() {
        return `${moment()
          .format('M/D/YYYY')},Week ${moment()
          .format('W')}`;
      },
    },
    watch: {
      getCurrentToolbarDisplay() {
        this.$store.commit('clearApiError');
      },
      getUserLocation(val) {
        this.updateUserLocation(val);
      },
      getUserIP(val) {
        this.updateUserIP(val);
      },         
    },
    created() {
      this.$store.dispatch('checkAuth');
      this.$store.dispatch('loadAllStoreOptions');
    },
    async mounted() {
      console.log("window location: " + window.location); 
      const loginurl = window.location;

      // this.$store.dispatch('loadMasterData', { group: 'OFFICE_IP' })
      //   .then((res) => {
      //     this.office_ips = res;
      // });


      //this.user_ip = JSON.stringify(this.getIP());
      if (this.getUserLocation == null || this.getUserLocation == "")
      {
         await this.$store.dispatch('checkUserLocation')
         .then(() => {
          this.user_location = JSON.stringify(this.getUserLocation);
          this.user_ip = JSON.stringify(this.getUserIP);
          console.log(`reload mounted user_ip: ${this.user_ip}`);
          console.log(`reload mounted user_location: ${this.user_location}`);
          if (loginurl && loginurl != "") {
             if (loginurl.toString().indexOf("-STC") > 1 
                 || loginurl.toString().indexOf("-stc") > 1) {
                this.isSTC = true;
                console.log("isSTC: " + this.isSTC);
             }
          }
         })
      } else {
        this.user_location = JSON.stringify(this.getUserLocation);
        this.user_ip = JSON.stringify(this.getUserIP);
        console.log(`mounted user_ip: ${this.user_ip}`);
        console.log(`mounted user_location: ${this.user_location}`);
        if (loginurl && loginurl != "") {
           if (loginurl.toString().indexOf("-STC") > 1 
                 || loginurl.toString().indexOf("-stc") > 1) {
              this.isSTC = true;
              console.log("isSTC: " + this.isSTC);
           }
        }
      }
      
      // this.$store.dispatch('checkUserLocation');
      // this.user_location = JSON.stringify(this.getUserLocation);
      // this.user_ip = JSON.stringify(this.getUserIP);
      // console.log(`mounted user_ip: ${this.user_ip}`);
      // console.log(`mounted user_location: ${this.user_location}`);
      // if (loginurl && loginurl != "") {
      //    if (loginurl.toString().indexOf("-STC") > 1 
      //          || loginurl.toString().indexOf("-stc") > 1) {
      //       this.isSTC = true;
      //       console.log("isSTC: " + this.isSTC);
      //    }
      // }
    },
    methods: {
      toggleMenu() {
        this.menuVisible = !this.menuVisible;
      },
      logout() {
        this.$buefy.dialog.confirm({
                    title: 'Logout', 
                    message: `Are you sure you want to Logout?`,
                    confirmText: 'Logout',
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: async () => {
                      this.$store.dispatch('logout', true);
                    }
            })
      },
      getRouteLinkActiveClass(path) {
        const match = !!_(this.$route.matched)
          .find(it => it.path.indexOf(path) !== -1);
        if (match) {
          if (path.indexOf('inboundAppt') > 0)
          {
             return { 'router-link-active-appt': true};
          } else if (path.indexOf('inboundScale') > 0){
             return { 'router-link-active-scale': true};
          } else if (path.indexOf('inboundTM') > 0) {
             return { 'router-link-active-tm': true};
          } else {
            return {
              'router-link-active': true,
            };
          }


        }
        return {};
      },
      refreshPage() {
        window.location.reload(true);
      },
      // async getIP() {

      //   var ips = [];
      //   var req = [];
      //   req.push('OFFICE_IP');
      //   await api.post("/api/w/masterData",{groups: req})
      //          .then( (res) => {
      //            ips = res;
      //            console.log(`ips from db: ${JSON.stringify(ips)}`);
      //          })
      //          .then( () => {
      //              fetch('https://api.ipify.org?format=json')
      //               .then(x => x.json())
      //                .then(({ ip }) => {
      //                  //var t_ip = `user's ip ${ip}`;
      //                  //var login_office = this.getMasterDataByGroup('OFFICE_IP');
      //                  console.log(`compare ip with master data`);
      //                  var login_office_info = ips.filter((it) => it.tagName == ip);
      //                  var login_office = "";
      //                  if (login_office_info && login_office_info.length > 0)
      //                  {
      //                     login_office = login_office_info[0].tagId;
      //                     this.user_location = JSON.stringify(login_office).replaceAll('"','');
      //                  }
      //                  console.log(`office_ips: ${this.user_location}`);
      //                  this.user_ip = JSON.stringify(ip).replaceAll('"','');
      //                  console.log(`ip: ${ip}, user_ip: ${this.user_ip}`);
      //                  //return ip;
      //                 //return ip;
      //               }); 
      //          }) 
      // },
      updateUserLocation(userloc) {
         this.user_location = JSON.parse(JSON.stringify(userloc));
         console.log(`read user location: ${this.user_location}`);
      },
      updateUserIP(userip) {
         this.user_ip = JSON.parse(JSON.stringify(userip));
         console.log(`read user ip: ${this.user_ip}`);
      },
    },
  };

</script>
